import cnContent from "./token/ja/cn.js";
import usContent from "./token/ja/us.js";
import jpContent from "./token/ja/jp.js";
import koContent from "./token/ja/ko.js";
import geContent from "./token/ja/ge.js";
import ukContent from "./token/ja/uk.js";
import uaeContent from "./token/ja/uae.js";
import frContent from "./token/ja/fr.js";
import sgContent from "./token/ja/sg.js";

import agreementContent from "./agreement/ja-jp.js";

export default {
  // ===== ヘッダー =====
  "head.index": "ホーム",
  "head.product": "製品",
  "head.computeProduct": "コンピューティング製品",
  "head.computeProductDesc":
    "コンピューティングパワー値を購入して、グローバルなコンピューティング収益を獲得",
  "head.rentalProduct": "レンタル製品",
  "head.rentalProductDesc": "高性能サーバーをレンタルして、安定した収益を得る",
  "head.rental": "レンタル",
  "head.about": "会社概要",

  // ===== ユーザードロップダウンメニュー =====
  "menu.profile": "マイページ",
  "menu.security": "アカウントセキュリティ",
  "menu.settings": "設定",
  "menu.products": "製品リスト",
  "menu.deposits": "入金履歴",
  "menu.withdraws": "出金履歴",
  "menu.walletLog": "取引履歴",
  "menu.logout": "ログアウト",
  "menu.logoutSuccess": "ログアウトに成功しました",

  // ===== フッター =====
  "footer.contactEmail": "お問い合わせメール",

  // ===== ホームページ =====
  "home.heroTitle1": "グローバル新コンピューティングロード",
  "home.heroTitle2": "ツインホイール駆動の富エンジン",
  "home.heroDesc":
    "プラットフォームは、Microsoft、OpenAI、DeepSeekなどの大規模モデル大手が事前にリースを確保している成熟したサイトを優先的に選択します",
  "home.heroBtn": "今すぐコンピューティング収益を獲得 →",
  "home.statTrade": "日次取引額",
  "home.statTradeValue": "10億+",
  "home.statReliability": "信頼性",
  "home.statGlobal": "グローバルサービス",
  "home.buildTitle1": "あなたの",
  "home.buildTitle2": "専用コンピューティングルームを建設",
  "home.buildDesc1":
    "独立管理 · 独立リース · 透明な収益 —— 私たちは運用管理のみを担当し、",
  "home.buildDesc2": "全ての収益は建設者に帰属します",
  "home.buildFeature1Title": "独立管理",
  "home.buildFeature1Desc":
    "ルームの完全な制御権を所有し、リース戦略と価格設定を自ら決定できます",
  "home.buildFeature2Title": "透明な収益",
  "home.buildFeature2Desc":
    "リアルタイムの財務データを可視化し、すべての収益を明確に確認できます",
  "home.buildFeature3Title": "専門的な運用",
  "home.buildFeature3Desc":
    "ハードウェアメンテナンス、ネットワーク保証、24時間365日のテクニカルサポートを提供します",
  "home.buildFeature4Title": "収益はすべてあなたのもの",
  "home.buildFeature4Desc":
    "基本的な運用コストを差し引いた後、すべてのリース収益は建設者に帰属します",
  "home.buildBtn": "今すぐ建設 →",
  "home.buildStatsTitle": "📈 建設収益概要",
  "home.buildStatsUpdate": "リアルタイム更新",
  "home.buildStatRooms": "完成したコンピューティングルーム",
  "home.buildStatServers": "稼働中のサーバー",
  "home.buildStatProfit": "建設者総収益",
  "home.buildStatPayback": "平均回収期間",
  "home.buildStatMonth": "ヶ月",
  "home.buildCta":
    "🎯 今すぐ参加して、コンピューティングインフラ事業を始めましょう",
  "home.buildCtaBtn": "詳細を見る",
  "home.featuresBadge": "✦ 中核的優位性",
  "home.featuresTitle1": "AETRIVOLを",
  "home.featuresTitle2": "選ぶ理由",
  "home.feature1Title": "高効率・便利",
  "home.feature1Desc":
    "AETRIVOLは自社の強みを活かし、個人がコンピューティング時代の恩恵を受けられる機会を提供します",
  "home.feature2Title": "国家レベルのセキュリティ",
  "home.feature2Desc":
    "多層ネットワーク保護、暗号化データ転送、24時間365日のセキュリティ監視",
  "home.feature3Title": "高性能ハードウェア",
  "home.feature3Desc":
    "NVIDIA最新世代GPU、高速NVMeストレージ、DDR5メモリを搭載",
  "home.feature4Title": "グローバルノード",
  "home.feature4Desc":
    "アジア太平洋、ヨーロッパ、北米のデータセンターをカバーし、低遅延のグローバルアクセラレーションを実現",
  "home.appBadge": "📱 モバイル",
  "home.appTitle": "近日公開",
  "home.appDesc1": "AETRIVOL モバイルアプリは近日公開予定です。",
  "home.appDesc2": "いつでもどこでもコンピューティング市場の動向を把握し、",
  "home.appDesc3": "ワンタッチでGPUコンピューティングパワーを管理できます。",
  "home.appQrText": "QRコードをスキャンしてアプリをダウンロード",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "協力",
  "home.walletsTitle2": "パートナー",
  "home.walletsDesc": "信頼できるウォレットと連携し、資産を安全に管理",
  "home.settleTitle1": "リアルタイム",
  "home.settleTitle2": "決済動向",
  "home.settleDesc": "グローバルユーザーのリアルタイム収益決済を表示",
  "home.modalTitle": "近日公開",
  "home.modalDesc1":
    "現在、新しいコンピューティングルーム建設プロジェクトはありません",
  "home.modalDesc2": "ご関心とご支援に感謝いたします！",
  "home.modalBtn": "承知しました",

  // ===== ホームページ-コンピューティング国 =====
  "tokenList.title1": "あなたの",
  "tokenList.title2": "コンピューティング国を選択",
  "tokenList.desc": "世界をリードするコンピューティング国、低投資・高リターン",
  "tokenList.buy": "今すぐ購入",
  "tokenList.more": "さらに見る",
  "tokenList.tagHot": "🔥 人気",
  "tokenList.tagProfit": "💰 高収益",
  "tokenList.tagRecommend": "⭐ おすすめ",
  "tokenList.tagNew": "🆕 新製品",

  // ===== ホームページ-サーバーレンタル =====
  "serverList.title1": "サーバー",
  "serverList.title2": "レンタル",
  "serverList.desc": "成熟した高性能サーバーで、超過収益を生み出しましょう",
  "serverList.dailyIncome": "日次収益",
  "serverList.value": "サーバー価値",
  "serverList.yield": "収益率",
  "serverList.gpu": "GPU",
  "serverList.vram": "ビデオメモリ",
  "serverList.storage": "ストレージ",
  "serverList.status": "ステータス",
  "serverList.available": "✅ レンタル可",
  "serverList.full": "⏳ 満員",
  "serverList.countdown": "開始まで",
  "serverList.days": "日",
  "serverList.over": "終了まで",
  "serverList.yunxz": "稼働中",
  "serverList.yunxzjs": "終了まで",
  "serverList.btnFull": "満員",
  "serverList.btnRent": "今すぐレンタル →",
  "serverList.btnWait": "開始待ち",
  "serverList.look": "詳細を見る",
  "serverList.btnEnded": "終了",
  "serverList.more": "さらに見る",
  "serverList.spec1": "エントリー版",
  "serverList.spec2": "ライト版",
  "serverList.spec3": "パフォーマンス版",
  "serverList.spec4": "フラッグシップ版",
  "serverList.tagHot": "🔥 人気",
  "serverList.tagRecommend": "⭐ おすすめ",
  "serverList.tagNew": "🌟 新発売",

  // ===== ホームページ-決済カルーセル =====
  "settle.amount": "決済額",
  "settle.status": "決済済み",
  "settle.power": "コンピューティングパワー値",
  "settle.rental": "サーバーレンタル",
  "settle.basic": "基本収益",
  "settle.cycle": "サイクル収益",
  "settle.phase1": "フェーズ1",
  "settle.phase2": "フェーズ2",
  "settle.phase3": "フェーズ3",
  "settle.phase4": "フェーズ4",

  // ===== メンバーセンター =====
  "member.recharge": "チャージ",
  "member.withdraw": "出金",
  "member.tabProducts": "マイ製品",
  "member.tabHistory": "履歴",
  "member.tabWalletLog": "ウォレット履歴",
  "member.tabDeposits": "入金履歴",
  "member.tabWithdraws": "出金履歴",
  "member.tabAddresses": "出金アドレス",
  "member.avatarAlt": "ユーザーアバター",
  "member.settingsTitle": "設定",
  "member.logoutTitle": "ログアウト",
  "member.tabTokenProduct": "コンピューティング製品",
  "member.tabRentProduct": "レンタル製品",

  // ===== 設定ページ =====
  "setting.back": "戻る",
  "setting.title": "⚙️ 設定",
  "setting.menuProfile": "個人情報",
  "setting.menuSecurity": "アカウントセキュリティ",
  "setting.menuVerify": "アカウント認証",
  "setting.menuChangePwd": "パスワード変更",
  "setting.menuTradePwd": "取引パスワード",
  "setting.getUserInfoFail": "ユーザー情報の取得に失敗しました",

  // ===== 設定ページ-個人情報 =====
  "profile.title": "個人情報",
  "profile.subtitle": "基本情報を管理",
  "profile.avatar": "アバター",
  "profile.avatarAlt": "アバター",
  "profile.changeAvatar": "アバター変更",
  "profile.systemAvatar": "システムアバター",
  "profile.firstName": "名",
  "profile.firstNamePlaceholder": "名を入力してください",
  "profile.lastName": "姓",
  "profile.lastNamePlaceholder": "姓を入力してください",
  "profile.phone": "電話番号",
  "profile.phonePlaceholder": "電話番号を入力してください",
  "profile.address": "住所",
  "profile.addressPlaceholder": "住所を入力してください",
  "profile.saving": "保存中...",
  "profile.saveInfo": "情報を保存",
  "profile.selectSystemAvatar": "システムアバターを選択",
  "profile.avatarAltNum": "アバター{count}",
  "profile.selectImageFile": "画像ファイルを選択してください",
  "profile.imageTooLarge": "画像サイズは5MBを超えることはできません",
  "profile.uploadFail": "アップロード失敗",
  "profile.updateFail": "更新失敗",
  "profile.updateSuccess": "更新成功",
  "profile.uploadFailNoPath":
    "アップロード失敗、画像アドレスを取得できませんでした",
  "profile.uploadFailRetry":
    "アップロード失敗、しばらくしてから再試行してください",
  "profile.saveFail": "保存失敗",
  "profile.saveSuccess": "保存成功",
  "profile.saveFailRetry": "保存失敗、しばらくしてから再試行してください",

  // ===== 設定ページ-アカウント認証 =====
  "verifyPanel.title": "アカウント認証",
  "verifyPanel.subtitle": "アカウント権限と信頼レベルを向上",
  "verifyPanel.realName": "本人確認",
  "verifyPanel.realNameDesc": "本人確認情報を提出済みです",
  "verifyPanel.verified": "認証済み ✓",
  "verifyPanel.goVerify": "認証へ →",

  // ===== 設定ページ-アカウントセキュリティ =====
  "securityPanel.title": "アカウントセキュリティ",
  "securityPanel.subtitle": "アカウントの安全を確保",
  "securityPanel.phoneBind": "電話番号連携",
  "securityPanel.phoneBound": "連携済み {phone}",
  "securityPanel.notBound": "未連携",
  "securityPanel.emailBind": "メール連携",
  "securityPanel.emailBound": "連携済み {email}",
  "securityPanel.twofa": "二段階認証 (2FA)",
  "securityPanel.twofaOn": "有効 · ログイン毎に動的認証コードが必要",
  "securityPanel.twofaOff":
    "無効 · アカウントセキュリティ強化のため有効化を推奨",
  "securityPanel.twofaEnabled": "有効 ✓",
  "securityPanel.enableTwofa": "二段階認証を有効化",
  "securityPanel.disableTwofaTitle": "二段階認証を無効化",
  "securityPanel.enableTwofaTitle": "二段階認証を有効化",
  "securityPanel.qrAlt": "二段階認証QRコード",
  "securityPanel.tip1":
    "1. Google Authenticator または Microsoft Authenticator をダウンロード",
  "securityPanel.tip2":
    "2. 上記のQRコードをスキャン または シークレットキーを入力",
  "securityPanel.copy": "コピー",
  "securityPanel.verifyCode": "認証コード",
  "securityPanel.verifyCodePlaceholder": "6桁の動的認証コードを入力",
  "securityPanel.emailCode": "メール認証コード",
  "securityPanel.emailCodePlaceholder": "メール認証コードを入力",
  "securityPanel.resend": "{count}秒後に再送信",
  "securityPanel.sendCode": "認証コードを送信",
  "securityPanel.disableWarning1":
    "二段階認証を無効にすると、アカウントの追加のセキュリティ保護が失われます。",
  "securityPanel.disableWarning2": "二段階認証を無効にしてもよろしいですか？",
  "securityPanel.cancel": "キャンセル",
  "securityPanel.confirmDisable": "無効化を確認",
  "securityPanel.confirmEnable": "有効化を確認",
  "securityPanel.getSecretFail": "シークレットキーの取得に失敗しました",
  "securityPanel.copySuccess":
    "シークレットキーをクリップボードにコピーしました",
  "securityPanel.copyFail": "シークレットキーのコピーに失敗しました",
  "securityPanel.enterVerifyCode": "6桁の動的認証コードを入力してください",
  "securityPanel.operationFail": "操作に失敗しました",
  "securityPanel.twofaEnabledMsg": "二段階認証が有効になりました！",
  "securityPanel.twofaDisabledMsg": "二段階認証が無効になりました！",
  "securityPanel.enterEmailCode": "メール認証コードを入力してください",

  // ===== 設定ページ-パスワード変更 =====
  "changePwd.title": "パスワード変更",
  "changePwd.subtitle": "定期的なパスワード変更でアカウントを安全に",
  "changePwd.warning":
    "二段階認証が有効になっていないため、パスワードを変更できません。先に二段階認証を有効にしてください。",
  "changePwd.goEnable": "有効化へ",
  "changePwd.newPwd": "新しいパスワード",
  "changePwd.newPwdPlaceholder": "新しいパスワードを入力（6文字以上）",
  "changePwd.confirmPwd": "新しいパスワード（確認）",
  "changePwd.confirmPwdPlaceholder": "新しいパスワードを再度入力",
  "changePwd.emailCode": "メール認証コード",
  "changePwd.emailCodePlaceholder": "メール認証コードを入力",
  "changePwd.resend": "{count}秒後に再送信",
  "changePwd.sendCode": "認証コードを送信",
  "changePwd.confirmBtn": "変更を確認",
  "changePwd.twofaDesc":
    "メール認証コードを送信するために、二段階認証コードを入力してください",
  "changePwd.pwdTooShort": "新しいパスワードは6文字以上必要です",
  "changePwd.pwdMismatch": "入力された新しいパスワードが一致しません",
  "changePwd.enableTwofaFirst":
    "パスワードを変更する前に二段階認証を有効にしてください",
  "changePwd.codeError": "認証コードが正しくありません",
  "changePwd.enterEmailCode": "メール認証コードを入力してください",
  "changePwd.success": "パスワードが変更されました！再ログインしてください",

  // ===== 設定ページ-取引パスワード =====
  "tradePwd.title": "取引パスワード",
  "tradePwd.subtitle": "資産の安全を保護",
  "tradePwd.warning":
    "二段階認証が有効になっていないため、取引パスワードを変更できません。先に二段階認証を有効にしてください。",
  "tradePwd.goEnable": "有効化へ",
  "tradePwd.newPwd": "新しい取引パスワード",
  "tradePwd.newPwdPlaceholder": "新しい取引パスワードを入力（6文字以上）",
  "tradePwd.confirmPwd": "取引パスワード（確認）",
  "tradePwd.confirmPwdPlaceholder": "新しい取引パスワードを再度入力",
  "tradePwd.emailCode": "メール認証コード",
  "tradePwd.emailCodePlaceholder": "メール認証コードを入力",
  "tradePwd.resend": "{count}秒後に再送信",
  "tradePwd.sendCode": "認証コードを送信",
  "tradePwd.confirmBtn": "変更を確認",
  "tradePwd.twofaDesc":
    "メール認証コードを送信するために、二段階認証コードを入力してください",
  "tradePwd.pwdTooShort": "新しい取引パスワードは6文字以上必要です",
  "tradePwd.pwdMismatch": "入力された取引パスワードが一致しません",
  "tradePwd.enableTwofaFirst":
    "取引パスワードを変更する前に二段階認証を有効にしてください",
  "tradePwd.codeError": "認証コードが正しくありません",
  "tradePwd.enterEmailCode": "メール認証コードを入力してください",
  "tradePwd.success": "取引パスワードが変更されました！",

  // ===== メンバーセンター-履歴 =====
  "history.tabToken": "コンピューティング履歴",
  "history.tabRent": "レンタル履歴",

  // ===== メンバーセンター-コンピューティング履歴 =====
  "historyToken.type": "タイプ",
  "historyToken.allType": "すべてのタイプ",
  "historyToken.buy": "購入",
  "historyToken.income": "収益",
  "historyToken.reset": "リセット",
  "historyToken.loading": "読み込み中...",
  "historyToken.empty": "製品がありません",
  "historyToken.date": "日付",
  "historyToken.product": "製品",
  "historyToken.quantity": "数量",
  "historyToken.amount": "金額",
  "historyToken.fee": "手数料",
  "historyToken.total": "合計",
  "historyToken.time": "時間",
  "historyToken.profit": "損益",
  "historyToken.deduct": "控除",
  "historyToken.profitPositive": "利益",
  "historyToken.profitNegative": "損失",
  "historyToken.unknownStatus": "不明なステータス",
  "historyToken.paginationInfo": "全 {total} 件中 {page} / {totalPages} ページ",
  "historyToken.firstPage": "最初",
  "historyToken.prevPage": "前へ",
  "historyToken.nextPage": "次へ",
  "historyToken.lastPage": "最後",
  "historyToken.perPage": "{count}件/ページ",

  // ===== メンバーセンター-レンタル履歴 =====
  "historyServer.type": "タイプ",
  "historyServer.allType": "すべてのタイプ",
  "historyServer.buy": "購入",
  "historyServer.income": "収益",
  "historyServer.reset": "リセット",
  "historyServer.loading": "読み込み中...",
  "historyServer.empty": "製品がありません",
  "historyServer.date": "日付",
  "historyServer.product": "製品",
  "historyServer.share": "シェア",
  "historyServer.amount": "金額",
  "historyServer.fee": "手数料",
  "historyServer.total": "合計",
  "historyServer.time": "時間",
  "historyServer.unknownStatus": "不明なステータス",
  "historyServer.paginationInfo":
    "全 {total} 件中 {page} / {totalPages} ページ",
  "historyServer.firstPage": "最初",
  "historyServer.prevPage": "前へ",
  "historyServer.nextPage": "次へ",
  "historyServer.lastPage": "最後",
  "historyServer.perPage": "{count}件/ページ",

  // ===== メンバーセンター-入金履歴 =====
  "deposit.loading": "読み込み中...",
  "deposit.empty": "入金履歴がありません",
  "deposit.coin": "通貨",
  "deposit.quantity": "数量",
  "deposit.network": "ネットワーク",
  "deposit.address": "アドレス",
  "deposit.status": "ステータス",
  "deposit.time": "時間",
  "deposit.success": "成功",
  "deposit.processing": "処理中",
  "deposit.paginationInfo": "全 {total} 件中 {page} / {totalPages} ページ",
  "deposit.firstPage": "最初",
  "deposit.prevPage": "前へ",
  "deposit.nextPage": "次へ",
  "deposit.lastPage": "最後",
  "deposit.perPage": "{count}件/ページ",

  // ===== メンバーセンター-出金履歴 =====
  "withdrawal.loading": "読み込み中...",
  "withdrawal.empty": "出金履歴がありません",
  "withdrawal.coin": "通貨",
  "withdrawal.quantity": "数量",
  "withdrawal.network": "ネットワーク",
  "withdrawal.address": "アドレス",
  "withdrawal.status": "ステータス",
  "withdrawal.time": "時間",
  "withdrawal.statusProcessing": "処理中",
  "withdrawal.statusSuccess": "成功",
  "withdrawal.statusFailed": "失敗",
  "withdrawal.statusUnknown": "不明",
  "withdrawal.paginationInfo": "全 {total} 件中 {page} / {totalPages} ページ",
  "withdrawal.firstPage": "最初",
  "withdrawal.prevPage": "前へ",
  "withdrawal.nextPage": "次へ",
  "withdrawal.lastPage": "最後",
  "withdrawal.perPage": "{count}件/ページ",

  // ===== メンバーセンター-出金アドレス =====
  "addresse.title": "出金アドレス",
  "addresse.addAddress": "+ アドレスを追加",
  "addresse.loading": "読み込み中...",
  "addresse.empty": "出金アドレスがありません",
  "addresse.coin": "通貨",
  "addresse.network": "ネットワーク",
  "addresse.address": "アドレス",
  "addresse.time": "時間",
  "addresse.action": "操作",
  "addresse.delete": "削除",
  "addresse.deleteConfirm":
    "この出金アドレスを削除してもよろしいですか？この操作は取り消せません。",
  "addresse.cancel": "キャンセル",
  "addresse.confirmDelete": "削除を確認",
  "addresse.deleteSuccess": "削除成功",
  "addresse.paginationInfo": "全 {total} 件中 {page} / {totalPages} ページ",
  "addresse.firstPage": "最初",
  "addresse.prevPage": "前へ",
  "addresse.nextPage": "次へ",
  "addresse.lastPage": "最後",
  "addresse.perPage": "{count}件/ページ",

  // ===== メンバーセンター-ウォレット履歴 =====
  "walletLog.type": "タイプ",
  "walletLog.allType": "すべてのタイプ",
  "walletLog.reset": "リセット",
  "walletLog.loading": "読み込み中...",
  "walletLog.empty": "製品がありません",
  "walletLog.project": "プロジェクト",
  "walletLog.amount": "金額",
  "walletLog.time": "時間",
  "walletLog.day": "日",
  "walletLog.paginationInfo": "全 {total} 件中 {page} / {totalPages} ページ",
  "walletLog.firstPage": "最初",
  "walletLog.prevPage": "前へ",
  "walletLog.nextPage": "次へ",
  "walletLog.lastPage": "最後",
  "walletLog.perPage": "{count}件/ページ",
  "walletLog.typeDeposit": "入金",
  "walletLog.typeWithdraw": "出金",
  "walletLog.typePay": "支払い",
  "walletLog.typeTokenIncome": "コンピューティング利益",
  "walletLog.typeTokenLoss": "コンピューティング損失",
  "walletLog.typeServerIncome": "サーバー収益",
  "walletLog.typeTransferReturn": "出金戻し",
  "walletLog.typeFreezeBuy": "(購入)凍結",
  "walletLog.typeServerRent": "サーバー賃料",
  "walletLog.typeUnfreeze": "(期限切れ)凍結解除",
  "walletLog.typeCompute": "コンピューティング",
  "walletLog.typeRent": "レンタル",
  "walletLog.statusUnknown": "不明なステータス",
  "walletLog.titlePower": "コンピューティングパワー",
  "walletLog.titleRent": "レンタル",
  "walletLog.statusDeposit": "入金",
  "walletLog.statusWithdrawal": "出金",
  "walletLog.statusPay": "支払い",
  "walletLog.statusPowerProfit": "コンピューティング利益",
  "walletLog.statusPowerLoss": "コンピューティング損失",
  "walletLog.statusServerIncome": "サーバー収益",
  "walletLog.statusWithdrawalReturn": "出金戻し",
  "walletLog.statusPurchaseFreeze": "(購入)凍結",
  "walletLog.statusServerRent": "サーバー賃料",
  "walletLog.statusExpireUnfreeze": "(期限切れ)凍結解除",

  // ===== メンバーセンター-資産概要 =====
  "memberBox.assetOverview": "資産概要",
  "memberBox.realTime": "リアルタイム更新",
  "memberBox.totalAssets": "総資産",
  "memberBox.vsYesterday": "前日比",
  "memberBox.availableBalance": "利用可能残高",
  "memberBox.frozenFunds": "拘束資金",
  "memberBox.incomeTrend": "収益トレンド",
  "memberBox.hashIncome": "コンピューティング収益",
  "memberBox.leaseIncome": "レンタル収益",
  "memberBox.hashIncomeTotal": "コンピューティング収益総額",
  "memberBox.leaseIncomeTotal": "レンタル収益総額",
  "memberBox.totalIncome": "総収益",
  "memberBox.vsLastDay": "前日比",
  "memberBox.time7d": "7日",
  "memberBox.time15d": "15日",
  "memberBox.time30d": "30日",

  // ===== メンバーセンター-製品リスト =====
  "productToken.region": "地域",
  "productToken.allRegion": "すべての地域",
  "productToken.status": "ステータス",
  "productToken.allStatus": "すべてのステータス",
  "productToken.statusActive": "進行中",
  "productToken.statusCompleted": "完了",
  "productToken.statusFrozen": "凍結",
  "productToken.statusUnknown": "不明なステータス",
  "productToken.reset": "リセット",
  "productToken.loading": "読み込み中...",
  "productToken.empty": "製品がありません",
  "productToken.quantity": "数量",
  "productToken.period": "期間",
  "productToken.latestProfit": "最新損益",
  "productToken.settledProfit": "決済済み損益",
  "productToken.periodProfit": "期間損益",
  "productToken.totalProfit": "損益総額",
  "productToken.action": "操作",
  "productToken.view": "表示",
  "productToken.day": "日",
  "productToken.paginationInfo": "全 {total} 件中 {page} / {totalPages} ページ",
  "productToken.firstPage": "最初",
  "productToken.prevPage": "前へ",
  "productToken.nextPage": "次へ",
  "productToken.lastPage": "最後",
  "productToken.perPage": "{count}件/ページ",
  "productToken.detailTitle": "製品詳細",
  "productToken.productCode": "製品コード",
  "productToken.orderCode": "注文番号",
  "productToken.orderName": "製品名",
  "productToken.tradeInfo": "取引情報",
  "productToken.tradeTime": "取引時間",
  "productToken.buyPrice": "購入価格",
  "productToken.principal": "元本",
  "productToken.fee": "手数料",
  "productToken.latestPrice": "最新価格",
  "productToken.profitInfo": "損益情報",
  "productToken.estimatedProfit": "推定総損益",
  "productToken.remark": "備考",
  "productToken.close": "閉じる",

  // ===== メンバーセンター-サーバー製品リスト =====
  "productServer.region": "地域",
  "productServer.allRegion": "すべての地域",
  "productServer.status": "ステータス",
  "productServer.allStatus": "すべてのステータス",
  "productServer.statusActive": "進行中",
  "productServer.statusCompleted": "完了",
  "productServer.statusFrozen": "凍結",
  "productServer.statusUnknown": "不明なステータス",
  "productServer.reset": "リセット",
  "productServer.loading": "読み込み中...",
  "productServer.empty": "製品がありません",
  "productServer.productName": "製品名",
  "productServer.share": "シェア",
  "productServer.countdown": "カウントダウン",
  "productServer.unsettledIncome": "未決済収益",
  "productServer.settled": "決済済み",
  "productServer.totalIncome": "収益総額",
  "productServer.action": "操作",
  "productServer.view": "表示",
  "productServer.day": "日",
  "productServer.paginationInfo":
    "全 {total} 件中 {page} / {totalPages} ページ",
  "productServer.firstPage": "最初",
  "productServer.prevPage": "前へ",
  "productServer.nextPage": "次へ",
  "productServer.lastPage": "最後",
  "productServer.perPage": "{count}件/ページ",
  "productServer.detailTitle": "製品詳細",
  "productServer.productCode": "製品コード",
  "productServer.orderCode": "注文番号",
  "productServer.orderName": "製品名",
  "productServer.leaseInfo": "レンタル情報",
  "productServer.leaseDate": "レンタル日",
  "productServer.rent": "賃料",
  "productServer.maintenanceFee": "メンテナンス費用",
  "productServer.profitInfo": "収益情報",
  "productServer.estimatedLeaseIncome": "推定総レンタル収益",
  "productServer.settledIncome": "決済済み収益",
  "productServer.phase": "{count}フェーズ",
  "productServer.currentPhase": "現在のフェーズ",
  "productServer.remark": "備考",
  "productServer.close": "閉じる",

  // ===== 登録/資格申請ページ =====
  "register.back": "ログインに戻る",
  "register.statusBadge": "資格申請 · 有人審査",
  "register.title": "資格権利を申請",
  "register.subtitle":
    "資料提出後、24時間以内に審査を完了し、メールでお知らせします",
  "register.basicInfo": "基本情報",
  "register.firstNamePlaceholder": "名を入力してください",
  "register.lastNamePlaceholder": "姓を入力してください",
  "register.genderMale": "男性",
  "register.genderFemale": "女性",
  "register.genderSecret": "非公開",
  "register.birthdayPlaceholder": "生年月日を選択してください",
  "register.maritalStatus": "婚姻状況",
  "register.maritalUnmarried": "未婚",
  "register.maritalMarried": "既婚",
  "register.maritalDivorced": "離婚",
  "register.maritalWidowed": "死別",
  "register.contactAddress": "連絡先住所",
  "register.addressPlaceholder": "連絡先住所を入力してください",
  "register.occupationInfo": "職業情報",
  "register.workUnitPlaceholder": "勤務先を入力してください",
  "register.workAddressPlaceholder": "勤務先住所を入力してください",
  "register.occupationPlaceholder": "職業を入力してください",
  "register.incomePlaceholder": "年収範囲を選択してください",
  "register.incomeBelow5": "5万未満",
  "register.income5to10": "5万 - 10万",
  "register.income10to20": "10万 - 20万",
  "register.income20to50": "20万 - 50万",
  "register.income50to100": "50万 - 100万",
  "register.incomeAbove100": "100万以上",
  "register.otherInfo": "その他情報",
  "register.remarksPlaceholder":
    "その他補足説明（任意、申請理由、特別な要件など）",
  "register.accountInfo": "アカウント情報",
  "register.inviteCodePlaceholder": "確認コードを入力してください",
  "register.emailPlaceholder":
    "メールアドレスを入力してください（審査結果はこのメールに送信されます）",
  "register.verifyCodePlaceholder": "メール認証コードを入力してください",
  "register.agreementText": "上記の情報が真実かつ有効であることを誓約し、",
  "register.agreementLink": "《利用規約》",
  "register.auditNotice1": "提出後、有人審査を実施します",
  "register.auditNotice2": "24時間以内",
  "register.auditNotice3":
    " にメールでお知らせします。メールアドレスが正しいことを確認してください。",
  "register.submitBtn": "審査申請を提出",
  "register.submitting": "提出中...",
  "register.hasAccount": "既にアカウントをお持ちですか？",
  "register.gotoLogin": "ログインへ",
  "register.successTitle": "提出完了！",
  "register.successDesc1": "資格申請を受領しました。",
  "register.successDesc2": "24時間以内",
  "register.successDesc3": " に審査を完了します。",
  "register.successDesc4": "審査結果は次のメールアドレスに送信されます：",
  "register.successTip": "メールをご確認ください。ご申請ありがとうございます！",
  "register.modalBtn": "承知しました",
  "register.sending": "送信中",
  "register.resendSuffix": "秒後に再送信",
  "register.auditNoticeMid": "、審査結果は",
  "register.invalidEmail": "有効なメールアドレスを入力してください",
  "register.codeSent": "認証コードをメールに送信しました。ご確認ください",
  "register.inviteCodeInvalid": "6桁の招待コードを入力してください",
  "register.verifyCodeInvalid": "4桁のメール認証コードを入力してください",
  "register.firstNameRequired": "本名（名）を入力してください",
  "register.lastNameRequired": "本名（姓）を入力してください",
  "register.genderRequired": "性別を選択してください",
  "register.birthdayRequired": "生年月日を選択してください",
  "register.maritalRequired": "婚姻状況を選択してください",
  "register.addressRequired": "住所を入力してください",
  "register.workUnitRequired": "勤務先を入力してください",
  "register.workAddressRequired": "勤務先住所を入力してください",
  "register.occupationRequired": "職業を入力してください",
  "register.incomeRequired": "年収範囲を選択してください",
  "register.agreeRequired":
    "資格審査条項とプライバシーポリシーを読み、同意してください",
  "register.registerFail": "登録失敗",
  "register.submitFail": "提出失敗、しばらくしてから再試行してください",

  // ===== ログインページ =====
  "login.title": "AIコンピューティングクラウド",
  "login.subtitle": "AI computing power cloud",
  "login.usernamePlaceholder": "ユーザー名を入力してください",
  "login.passwordPlaceholder": "パスワードを入力してください",
  "login.forgotPassword": "パスワードをお忘れですか？",
  "login.loginBtn": "ログイン",
  "login.noQualification": "資格をお持ちでないですか？",
  "login.applyNow": "今すぐ資格を申請",
  "login.loginSuccess": "ログイン成功",
  "login.enterCredentials": "ユーザー名とパスワードを入力してください",
  "login.loading": "読み込み中...",

  // ===== パスワードリセットページ =====
  "reset.back": "ログインに戻る",
  "reset.title": "パスワードを再設定",
  "reset.subtitleStep1": "身元を確認し、アカウントのパスワードを再設定します",
  "reset.subtitleStep2":
    "新しいパスワードを設定し、アカウントの安全を確保します",
  "reset.emailPlaceholder": "登録済みのメールアドレスを入力してください",
  "reset.captchaPlaceholder": "認証コードを入力してください",
  "reset.sending": "送信中",
  "reset.getCaptcha": "認証コードを取得",
  "reset.nextStep": "次へ",
  "reset.newPasswordPlaceholder": "新しいパスワードを設定（6文字以上）",
  "reset.confirmPasswordPlaceholder": "新しいパスワードを再度入力",
  "reset.resetBtn": "今すぐ再設定",
  "reset.rememberPassword": "パスワードを覚えていますか？",
  "reset.gotoLogin": "ログインへ",
  "reset.invalidEmail": "有効なメールアドレスを入力してください",
  "reset.captchaSent": "認証コードを送信しました",
  "reset.captchaInvalid": "有効な認証コードを入力してください（4文字以上）",
  "reset.passwordTooShort": "新しいパスワードは6文字以上必要です",
  "reset.passwordMismatch": "入力されたパスワードが一致しません",
  "reset.resetSuccess":
    "パスワードの再設定が完了しました！再ログインしてください",

  // ===== 本人確認ページ =====
  "verify.statusBadge": "本人確認 · 情報入力",
  "verify.title": "アカウント認証",
  "verify.subtitle":
    "実際の身元情報を入力してください。提出後、有人審査を実施します",
  "verify.accountSecurity": "アカウントセキュリティ",
  "verify.loginPassword": "ログインパスワード",
  "verify.confirmLoginPassword": "ログインパスワード（確認）",
  "verify.tradePassword": "取引パスワード",
  "verify.confirmTradePassword": "取引パスワード（確認）",
  "verify.securityQuestion": "セキュリティ質問",
  "verify.securityAnswer": "質問の回答",
  "verify.basicInfo": "基本情報",
  "verify.country": "国籍",
  "verify.countryPlaceholder": "国籍を選択してください",
  "verify.phone": "電話番号",
  "verify.realName": "本名",
  "verify.idNumber": "身分証明書番号",
  "verify.idPhoto": "身分証明書の写真",
  "verify.frontPhoto": "表面写真",
  "verify.backPhoto": "裏面写真",
  "verify.handPhoto": "身分証明書を手に持った写真",
  "verify.uploading": "アップロード中...",
  "verify.clickUpload": "クリックしてアップロード",
  "verify.uploadHint": "JPG / PNG 対応、5MB以内を推奨",
  "verify.uploadHandHint":
    "身分証明書を手に持って撮影し、顔と証明書の情報がはっきり見えるようにしてください",
  "verify.reupload": "再アップロード",
  "verify.auditNotice1": "提出後、有人審査を実施します",
  "verify.auditNoticeMid": "、審査結果は",
  "verify.auditNotice2": "24時間以内",
  "verify.auditNotice3":
    " にお知らせします。情報が正確であることを確認してください。",
  "verify.submitBtn": "認証を提出",
  "verify.submitting": "提出中...",
  "verify.hasAccount": "既にアカウントをお持ちですか？",
  "verify.gotoLogin": "ログインへ",
  "verify.successTitle": "提出完了！",
  "verify.successDesc1": "認証情報を提出しました。",
  "verify.successDesc2": "24時間以内",
  "verify.successDesc3": " に審査を完了します。",
  "verify.successDesc4": "審査結果はSMSでお知らせします。",
  "verify.successTip":
    "電話がつながるようにしておいてください。ご協力ありがとうございます！",
  "verify.modalBtn": "承知しました",
  "verify.loginPasswordPlaceholder": "ログインパスワードを設定（6文字以上）",
  "verify.confirmLoginPasswordPlaceholder": "ログインパスワードを再度入力",
  "verify.tradePasswordPlaceholder": "取引パスワードを設定（6文字以上）",
  "verify.confirmTradePasswordPlaceholder": "取引パスワードを再度入力",
  "verify.securityQuestionPlaceholder": "セキュリティ質問を入力してください",
  "verify.securityAnswerPlaceholder": "質問の回答を入力してください",
  "verify.phonePlaceholder": "電話番号を入力してください",
  "verify.realNamePlaceholder": "本名を入力（身分証明書と同じ）",
  "verify.idNumberPlaceholder": "身分証明書番号を入力してください",
  "verify.uploadImage": "画像ファイルをアップロードしてください",
  "verify.imageTooLarge": "画像サイズは5MBを超えることはできません",
  "verify.uploadSuccess": "画像のアップロードに成功しました",
  "verify.uploadFail": "画像のアップロードに失敗しました",
  "verify.uploadFailRetry":
    "画像のアップロードに失敗しました。しばらくしてから再試行してください",
  "verify.passwordTooShort": "パスワードは6文字以上必要です",
  "verify.confirmPasswordRequired": "パスワードを再度入力してください",
  "verify.passwordMismatch": "入力されたパスワードが一致しません",
  "verify.tradePasswordTooShort": "取引パスワードは6文字以上必要です",
  "verify.confirmTradePasswordRequired": "取引パスワードを再度入力してください",
  "verify.tradePasswordMismatch": "入力された取引パスワードが一致しません",
  "verify.securityQuestionRequired": "セキュリティ質問を入力してください",
  "verify.countryRequired": "国籍を選択してください",
  "verify.phoneInvalid": "有効な電話番号を入力してください",
  "verify.realNameRequired": "本名を入力してください（2文字以上）",
  "verify.idNumberInvalid": "有効な身分証明書番号を入力してください",
  "verify.idFrontRequired": "身分証明書の表面写真をアップロードしてください",
  "verify.idBackRequired": "身分証明書の裏面写真をアップロードしてください",
  "verify.idHandRequired":
    "身分証明書を手に持った写真をアップロードしてください",
  "verify.submitSuccess": "提出成功",
  "verify.submitFail": "提出失敗",
  "verify.submitFailRetry": "提出失敗、しばらくしてから再試行してください",

  // ===== レンタルリストページ =====
  "rental.title1": "サーバー",
  "rental.title2": "レンタル",
  "rental.desc":
    "厳選された高性能サーバーに投資し、個人のコンピューティング資産を構築し、グローバルなコンピューティングの発展を支援します",
  "rental.statServers": "レンタル可能なサーバー",
  "rental.statAvailability": "可用性",
  "rental.statSupport": "カスタマーサポート",
  "rental.searchPlaceholder": "サーバー名、GPUモデルで検索...",
  "rental.filterAll": "すべて",
  "rental.filterHot": "🔥 人気",
  "rental.filterRecommend": "⭐ おすすめ",
  "rental.filterNew": "🌟 新発売",
  "rental.sortDefault": "デフォルト順",
  "rental.sortRemainingAsc": "残り ↑",
  "rental.sortRemainingDesc": "残り ↓",
  "rental.sortValueAsc": "総価値 ↑",
  "rental.sortValueDesc": "総価値 ↓",
  "rental.sortIncomeAsc": "日収益 ↑",
  "rental.sortIncomeDesc": "日収益 ↓",
  "rental.sortStartAsc": "活動開始 ↑",
  "rental.sortStartDesc": "活動開始 ↓",
  "rental.sortEndAsc": "活動終了 ↑",
  "rental.sortEndDesc": "活動終了 ↓",
  "rental.resultCount": "全 {count} 台のサーバー",
  "rental.loading": "読み込み中...",
  "rental.empty": "該当するサーバーが見つかりません",
  "rental.totalValue": "総価値",
  "rental.country": "国",
  "rental.incomeTrend": "収益トレンド",
  "rental.activityPeriod": "📅 期間",
  "rental.remaining": "⏳ 残り",
  "rental.days": "日",
  "rental.memory": "メモリ",
  "rental.storage": "ストレージ",
  "rental.bandwidth": "帯域幅",
  "rental.status": "ステータス",
  "rental.available": "✅ レンタル可",
  "rental.full": "⏳ 満員",
  "rental.countdown": "開始まで",
  "rental.btnFull": "満員",
  "rental.btnRent": "今すぐレンタル",
  "rental.btnWait": "開始待ち",
  "rental.btnEnded": "終了",
  "rental.btnRentList": "レンタル",
  "rental.btnNotStart": "未開始",
  "rental.NotRent": "レンタル不可",
  "rental.value": "価値",
  "rental.prev": "← 前へ",
  "rental.next": "次へ →",
  "rental.perPage": "{count} 件/ページ",
  "rental.processBadge": "📋 レンタルプロセス",
  "rental.processTitle1": "3つの簡単な",
  "rental.processTitle2": "ステップでサーバーレンタル",
  "rental.step1Icon": "🔍",
  "rental.step1Title": "サーバーを選択",
  "rental.step1Desc": "サーバーリストを参照し、ニーズに合わせた構成を選択",
  "rental.step2Icon": "📝",
  "rental.step2Title": "レンタル申請を提出",
  "rental.step2Desc": "レンタル期間、用途などの情報を入力し、審査を提出",
  "rental.step3Icon": "🚀",
  "rental.step3Title": "デプロイして使用",
  "rental.step3Desc":
    "審査通過後、すぐにデプロイし、AIコンピューティングの旅を開始",
  "rental.ctaTitle": "適切なサーバーが見つかりませんか？",
  "rental.ctaDesc":
    "カスタマイズされたソリューションについてはお問い合わせください。専門チームが最適な構成を提案します",
  "rental.ctaContact": "カスタマーサポートへ",
  "rental.ctaFaq": "よくある質問を見る",
  "rental.spec1": "エントリー版",
  "rental.spec2": "ライト版",
  "rental.spec3": "パフォーマンス版",
  "rental.spec4": "フラッグシップ版",
  "rental.tagHot": "🔥 人気",
  "rental.tagRecommend": "⭐ おすすめ",
  "rental.tagNew": "🌟 新発売",
  "rental.statusActive": "進行中",
  "rental.statusPending": "未開始",
  "rental.statusEnded": "終了",
  "rental.income": "収益",
  "rental.progress": "進捗",
  "rental.countryAlt": "国",
  "rental.monday": "月",
  "rental.tuesday": "火",
  "rental.wednesday": "水",
  "rental.thursday": "木",
  "rental.friday": "金",
  "rental.saturday": "土",
  "rental.sunday": "日",

  // ===== 出金ページ =====
  "withdraw.title": "💸 出金",
  "withdraw.desc": "迅速な出金、安全な着金",
  "withdraw.balance": "利用可能残高",
  "withdraw.methodCrypto": "🪙 暗号資産",
  "withdraw.methodBank": "🏦 銀行出金",
  "withdraw.selectCoin": "通貨を選択",
  "withdraw.selectNetwork": "出金ネットワークを選択",
  "withdraw.address": "出金アドレス",
  "withdraw.bindAddress": "➕ アドレスを連携",
  "withdraw.selectAddress": "出金アドレスを選択してください",
  "withdraw.noAddress": "利用可能なアドレスがありません",
  "withdraw.noAddressTip": "⚠️ 連携済みの {coin} アドレスがありません。先に",
  "withdraw.bindLink": "アドレスを連携",
  "withdraw.amount": "出金額",
  "withdraw.emailCode": "メール認証コード",
  "withdraw.emailCodePlaceholder": "メール認証コードを入力",
  "withdraw.resend": "{count}秒後に再送信",
  "withdraw.sendCode": "認証コードを送信",
  "withdraw.expectedArrival": "予定着金",
  "withdraw.networkFee": "ネットワーク手数料",
  "withdraw.actualArrival": "実際の着金",
  "withdraw.submitting": "⏳ 送信中...",
  "withdraw.confirm": "🚀 出金を確認",
  "withdraw.selectFirst": "👆 通貨とネットワークを選択してください",
  "withdraw.minAmount": "最低出金額",
  "withdraw.maxAmount": "最大出金額",
  "withdraw.all": "すべて",
  "withdraw.available": "利用可能",
  "withdraw.insufficientBalance": "残高不足",
  "withdraw.enterAmount": "出金額を入力してください",
  "withdraw.enterCode": "メール認証コードを入力してください",
  "withdraw.selectAddressFirst": "出金アドレスを選択してください",
  "withdraw.success": "出金申請を送信しました",
  "withdraw.fail": "出金失敗",
  "withdraw.arrivalTime": "10～30分",
  "withdraw.noticeTitle": "📋 出金時の注意事項",
  "withdraw.notice1Title": "着金時間",
  "withdraw.notice1Desc":
    "暗号資産の出金は通常10～30分で着金します。ブロックチェーンネットワークの確認速度によって異なります。",
  "withdraw.notice2Title": "最低出金額",
  "withdraw.notice2Desc":
    "1回の出金の最低金額は0.001 BTCまたは他の通貨での同等額です。この金額を下回ると送信できません。",
  "withdraw.notice3Title": "アドレスの確認",
  "withdraw.notice3Desc":
    "出金アドレスをよく確認してください。誤った操作は資産の永久損失につながる可能性があり、プラットフォームは責任を負いません。",
  "withdraw.notice4Title": "手数料について",
  "withdraw.notice4Desc":
    "出金手数料はブロックチェーンネットワークによって決定され、プラットフォームは追加料金を請求しません。手数料は出金額から差し引かれます。",
  "withdraw.codeError": "認証コードが正しくありません",
  "withdraw.twoFactorDesc":
    "メール認証コードを送信するために、二段階認証コードを入力してください",
  "withdraw.selectBank": "銀行口座を選択",
  "withdraw.selectBankPlaceholder": "銀行口座を選択してください",
  "withdraw.bankBOC": "中国銀行",
  "withdraw.bankICBC": "工商銀行",
  "withdraw.addBank": "+ 新しい口座を追加",
  "withdraw.bankAmount": "出金額 (USD)",
  "withdraw.exchangeRate": "💱 為替レート",
  "withdraw.arrivalTimeLabel": "⏱️ 着金時間",
  "withdraw.bankArrivalTime": "1～3営業日",
  "withdraw.bankConfirm": "🏦 出金を確認",
  "withdraw.bankSuccess":
    "🏦 銀行出金申請を送信しました。1～3営業日以内に着金します",

  // ===== 入金ページ =====
  "depositPage.title": "💰 入金",
  "depositPage.desc": "入金方法を選択して、迅速にチャージ",
  "depositPage.balance": "現在の残高",
  "depositPage.methodCrypto": "🪙 暗号資産",
  "depositPage.methodOnline": "💳 オンライン入金",
  "depositPage.coin": "通貨",
  "depositPage.protocol": "プロトコル",
  "depositPage.qrAlt": "入金QRコード",
  "depositPage.qrPlaceholder": "QRコードはありません",
  "depositPage.copy": "📋 コピー",
  "depositPage.copied": "✅",
  "depositPage.addressWarning":
    "⚠️ <strong>{coin}</strong> ({protocol}) 転送のみ対応しています。他の資産は送信しないでください",
  "depositPage.amountPlaceholder": "入金額を入力（任意）",
  "depositPage.transferBtn": "🚀 送信済み",
  "depositPage.emptyState": "👆 通貨とプロトコルを選択してください",
  "depositPage.noticeTitle": "📋 入金時の注意事項",
  "depositPage.onlineCardName1": "クレジット/デビットカード",
  "depositPage.onlineCardDesc1": "Visa · Mastercard",
  "depositPage.onlineCardBtn1": "支払い →",
  "depositPage.onlineCardName2": "銀行振込",
  "depositPage.onlineCardDesc2": "1～3営業日で着金",
  "depositPage.onlineCardBtn2": "情報取得 →",
  "depositPage.onlineCardName3": "サードパーティ決済",
  "depositPage.onlineCardDesc3": "支付宝 · WeChat · Paypal",
  "depositPage.onlineCardBtn3": "支払い →",
  "depositPage.notice1Title": "着金時間",
  "depositPage.notice1Desc":
    "暗号資産の入金はブロックチェーンネットワークの確認が必要で、通常10～30分かかります。ネットワークの混雑状況によって異なります。",
  "depositPage.notice2Title": "最低入金額",
  "depositPage.notice2Desc":
    "1回の入金の最低金額は0.001 BTCまたは他の通貨での同等額です。この金額を下回ると入金できません。",
  "depositPage.notice3Title": "確認数要件",
  "depositPage.notice3Desc":
    "BTCは3回、ETH/TRX/USDTは12回のネットワーク確認後に残高に反映されます。",
  "depositPage.notice4Title": "資産セキュリティの注意",
  "depositPage.notice4Desc":
    "入金アドレスとプロトコルタイプをよく確認してください。誤った操作は資産の永久損失につながる可能性があり、プラットフォームは責任を負いません。",
  "depositPage.feeInfo": "💸 手数料：{fee}",

  // ===== ウォレットアドレス連携ページ =====
  "bindAddress.title": "🔗 ウォレットアドレスを連携",
  "bindAddress.desc": "出金用に暗号資産ウォレットアドレスを連携",
  "bindAddress.cardTitle": "➕ 新しいウォレットを連携",
  "bindAddress.selectCoin": "通貨を選択",
  "bindAddress.selectProtocol": "プロトコルを選択",
  "bindAddress.walletAddress": "ウォレットアドレス",
  "bindAddress.walletAddressPlaceholder":
    "ウォレットアドレスを入力してください",
  "bindAddress.emailCode": "メール認証コード",
  "bindAddress.emailCodePlaceholder": "メール認証コードを入力",
  "bindAddress.resend": "{count}秒後に再送信",
  "bindAddress.sendCode": "認証コードを送信",
  "bindAddress.confirmBind": "🔗 連携を確認",
  "bindAddress.noticeTitle": "📋 連携時の注意事項",
  "bindAddress.twoFactorDesc":
    "メール認証コードを送信するために、二段階認証コードを入力してください",
  "bindAddress.notice1Title": "資産の安全",
  "bindAddress.notice1Desc":
    "連携するウォレットアドレスがご自身のものであり、秘密鍵はご自身で管理されていることを確認してください。",
  "bindAddress.notice2Title": "出金制限",
  "bindAddress.notice2Desc":
    "連携後24時間以内は出金できません。アカウントの資産を保護するためです。",
  "bindAddress.notice3Title": "メール認証",
  "bindAddress.notice3Desc":
    "新しいウォレットを連携するたびに、メール認証コードによる確認が必要です。",
  "bindAddress.notice4Title": "アドレスの確認",
  "bindAddress.notice4Desc":
    "ウォレットアドレスをよく確認してください。誤った連携は資産を回復できなくなる可能性があります。",
  "bindAddress.msgAddressInvalid":
    "⚠️ 正しいウォレットアドレスを入力してください",
  "bindAddress.msgCodeError": "認証コードが正しくありません",
  "bindAddress.msgFormInvalid":
    "すべての情報を入力し、メール認証コードを取得してください",

  // ===== エラーページ =====
  "error.backHome": "ホームに戻る",
  "error.refresh": "更新して再試行",
  "error.footerTip":
    "問題が解決しない場合は、テクニカルサポートにお問い合わせください",
  "error.title404": "ページが見つかりません",
  "error.desc404": "アクセスしたページは存在しないか、削除されました",

  phase: "フェーズ",

  // ja-jp 日语
  country: {
    1: "アメリカ",
    2: "中国",
    3: "日本",
    4: "韓国",
    5: "ドイツ",
    6: "イギリス",
    7: "フランス",
    8: "アラブ首長国連邦",
    9: "シンガポール",
    10: "イスラエル",
    11: "ロシア",
    12: "インド",
    13: "ブラジル",
    14: "イタリア",
    15: "スペイン",
    16: "ポルトガル",
    17: "オランダ",
    18: "ベルギー",
    19: "スイス",
    20: "スウェーデン",
    21: "ノルウェー",
    22: "フィンランド",
    23: "デンマーク",
    24: "アイスランド",
    25: "アイルランド",
    26: "オーストリア",
    27: "ポーランド",
    28: "チェコ",
    29: "ハンガリー",
    30: "ギリシャ",
    31: "ウクライナ",
    32: "ベラルーシ",
    33: "ルーマニア",
    34: "ブルガリア",
    35: "セルビア",
    36: "クロアチア",
    37: "アルバニア",
    38: "エストニア",
    39: "ラトビア",
    40: "リトアニア",
    41: "モルドバ",
    42: "スロバキア",
    43: "スロベニア",
    44: "ボスニア・ヘルツェゴビナ",
    45: "モンテネグロ",
    46: "北マケドニア",
    47: "ルクセンブルク",
    48: "マルタ",
    49: "アンドラ",
    50: "モナコ",
    51: "リヒテンシュタイン",
    52: "サンマリノ",
    53: "バチカン",
    54: "カナダ",
    55: "メキシコ",
    56: "キューバ",
    57: "グアテマラ",
    58: "ホンジュラス",
    59: "ニカラグア",
    60: "コスタリカ",
    61: "パナマ",
    62: "ジャマイカ",
    63: "ハイチ",
    64: "ドミニカ共和国",
    65: "トリニダード・トバゴ",
    66: "ドミニカ国",
    67: "セントルシア",
    68: "セントビンセント・グレナディーン",
    69: "グレナダ",
    70: "セントクリストファー・ネイビス",
    71: "アンティグア・バーブーダ",
    72: "バハマ",
    73: "バルバドス",
    74: "ベリーズ",
    75: "エルサルバドル",
    76: "アルゼンチン",
    77: "コロンビア",
    78: "ベネズエラ",
    79: "ペルー",
    80: "チリ",
    81: "エクアドル",
    82: "ボリビア",
    83: "パラグアイ",
    84: "ウルグアイ",
    85: "ガイアナ",
    86: "スリナム",
    87: "オーストラリア",
    88: "ニュージーランド",
    89: "パプアニューギニア",
    90: "フィジー",
    91: "ソロモン諸島",
    92: "バヌアツ",
    93: "サモア",
    94: "キリバス",
    95: "ミクロネシア連邦",
    96: "マーシャル諸島",
    97: "パラオ",
    98: "ナウル",
    99: "ツバル",
    100: "トンガ",
    101: "クック諸島",
    102: "ニウエ",
    103: "エジプト",
    104: "南アフリカ",
    105: "ナイジェリア",
    106: "エチオピア",
    107: "ケニア",
    108: "タンザニア",
    109: "アルジェリア",
    110: "モロッコ",
    111: "スーダン",
    112: "南スーダン",
    113: "ガーナ",
    114: "アンゴラ",
    115: "モザンビーク",
    116: "マダガスカル",
    117: "カメルーン",
    118: "コートジボワール",
    119: "ニジェール",
    120: "ブルキナファソ",
    121: "マリ",
    122: "セネガル",
    123: "ウガンダ",
    124: "ザンビア",
    125: "ジンバブエ",
    126: "チャド",
    127: "コンゴ共和国",
    128: "コンゴ民主共和国",
    129: "ガボン",
    130: "ボツワナ",
    131: "ナミビア",
    132: "モーリシャス",
    133: "ルワンダ",
    134: "ソマリア",
    135: "ジブチ",
    136: "エリトリア",
    137: "リビア",
    138: "チュニジア",
    139: "シエラレオネ",
    140: "リベリア",
    141: "トーゴ",
    142: "ベナン",
    143: "ギニア",
    144: "ギニアビサウ",
    145: "ガンビア",
    146: "カーボベルデ",
    147: "サントメ・プリンシペ",
    148: "赤道ギニア",
    149: "モーリタニア",
    150: "エスワティニ",
    151: "レソト",
    152: "マラウイ",
    153: "中央アフリカ共和国",
    154: "ブルンジ",
    155: "コモロ",
    156: "セーシェル",
    157: "トルコ",
    158: "イラン",
    159: "イラク",
    160: "サウジアラビア",
    161: "モンゴル",
    162: "北朝鮮",
    163: "インドネシア",
    164: "フィリピン",
    165: "ベトナム",
    166: "タイ",
    167: "マレーシア",
    168: "ミャンマー",
    169: "カンボジア",
    170: "ラオス",
    171: "ブルネイ",
    172: "東ティモール",
    173: "パキスタン",
    174: "バングラデシュ",
    175: "ネパール",
    176: "ブータン",
    177: "スリランカ",
    178: "モルディブ",
    179: "カザフスタン",
    180: "ウズベキスタン",
    181: "トルクメニスタン",
    182: "キルギス",
    183: "タジキスタン",
    184: "アフガニスタン",
    185: "シリア",
    186: "ヨルダン",
    187: "レバノン",
    188: "パレスチナ",
    189: "オマーン",
    190: "イエメン",
    191: "クウェート",
    192: "カタール",
    193: "バーレーン",
    194: "ジョージア",
    195: "アルメニア",
    196: "アゼルバイジャン",
    197: "キプロス",
  },

  token: {
    us: {
      content: {
        title: "",
        content: usContent.content,
      },
      t1: {
        title: "発展現状",
        content: usContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: usContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: usContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: usContent.t4,
      },
    },
    cn: {
      content: {
        title: "",
        content: cnContent.content,
      },
      t1: {
        title: "発展現状",
        content: cnContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: cnContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: cnContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: cnContent.t4,
      },
    },
    jp: {
      content: {
        title: "",
        content: jpContent.content,
      },
      t1: {
        title: "発展現状",
        content: jpContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: jpContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: jpContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: jpContent.t4,
      },
    },
    ko: {
      content: {
        title: "",
        content: koContent.content,
      },
      t1: {
        title: "発展現状",
        content: koContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: koContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: koContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: koContent.t4,
      },
    },
    ge: {
      content: {
        title: "",
        content: geContent.content,
      },
      t1: {
        title: "発展現状",
        content: geContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: geContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: geContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: geContent.t4,
      },
    },
    uk: {
      content: {
        title: "",
        content: ukContent.content,
      },
      t1: {
        title: "発展現状",
        content: ukContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: ukContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: ukContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: ukContent.t4,
      },
    },
    fr: {
      content: {
        title: "",
        content: frContent.content,
      },
      t1: {
        title: "発展現状",
        content: frContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: frContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: frContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: frContent.t4,
      },
    },
    uae: {
      content: {
        title: "",
        content: uaeContent.content,
      },
      t1: {
        title: "発展現状",
        content: uaeContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: uaeContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: uaeContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: uaeContent.t4,
      },
    },
    sg: {
      content: {
        title: "",
        content: sgContent.content,
      },
      t1: {
        title: "発展現状",
        content: sgContent.t1,
      },
      t2: {
        title: "中核的優位性",
        content: sgContent.t2,
      },
      t3: {
        title: "直面する課題",
        content: sgContent.t3,
      },
      t4: {
        title: "将来のトレンド",
        content: sgContent.t4,
      },
    },
  },

  // ===== ホームページ-補足（alt属性など） =====
  "home.altQr": "QRコードをスキャンしてダウンロード",
  "home.altApp": "アプリのスクリーンショット",
  "home.altWallet": "ウォレットアイコン",

  // ===== レンタル詳細ページ =====
  "detail.breadcrumbHome": "ホーム",
  "detail.breadcrumbRental": "サーバーレンタル",
  "detail.breadcrumbDetail": "詳細",
  "detail.badgeHot": "🔥 人気おすすめ",
  "detail.badgeAvailable": "✅ レンタル可",
  "detail.badgeSold": "⏳ 満員",
  "detail.badgeEnded": "⏳ 終了",
  "detail.badgePending": "⏳ 未開始",
  "detail.code": "コード: ",
  "detail.specTitle": "完全な仕様",
  "detail.specGpu": "GPU モデル",
  "detail.specVram": "ビデオメモリ容量",
  "detail.specStorage": "ストレージ容量",
  "detail.specRam": "メモリ",
  "detail.specBandwidth": "帯域幅",
  "detail.specValue": "サーバー価値",
  "detail.specCountry": "国",
  "detail.specCountryFlag": "国旗",
  "detail.specStatus": "ステータス",
  "detail.statusFull": "⏳ 満員",
  "detail.statusEnded": "⏳ 終了",
  "detail.statusPending": "⏳ 未開始",
  "detail.statusAvailable": "✅ レンタル可",
  "detail.chartTitle": "収益トレンド",
  "detail.chartRealTime": "リアルタイム",
  "detail.chartHint": "クリックして拡大",
  "detail.chart7d": "7日",
  "detail.chart15d": "15日",
  "detail.chart30d": "30日",
  "detail.statMax": "最高",
  "detail.statAvg": "平均",
  "detail.statMin": "最低",
  "detail.statChange": "上昇率",
  "detail.descTitle": "製品説明",
  "detail.regionTitle": "地域説明",
  "detail.panelTitle": "💎 今すぐレンタル",
  "detail.statusDotFull": "● 満員",
  "detail.statusDotEnded": "● 終了",
  "detail.statusDotPending": "● 未開始",
  "detail.statusDotAvailable": "● レンタル可",
  "detail.activityPeriod": "📅 周期時間",
  "detail.daysLeft": "残り",
  "detail.days": "日",
  "detail.subscribeShare": "🎚️ 購入シェア",
  "detail.customShare": "カスタムシェア",
  "detail.remainingShare": "残りシェア",
  "detail.shareMsg":
    "購入比率は残りの{n}%コンピューティングパワー値を超えることはできません",
  "detail.incomeDetail": "📈 推定収益明細",
  "detail.incomeTip":
    "推定収益は参考値です。実際の収益は決済データに基づきます。",
  "detail.estimate": "推定",
  "detail.rate": "収益率:",
  "detail.settleDate": "決済日:",
  "detail.moreStages": "あと {count} フェーズ",
  "detail.hoverExpand": "ホバーで展開",
  "detail.totalIncome": "推定収益総額",
  "detail.fundDetail": "💰 資金明細",
  "detail.rentalAmount": "レンタル金額",
  "detail.maintenanceFee": "メンテナンス費用",
  "detail.feeFormula": "総価値*{percent}%*{fee}%",
  "detail.tierDiscount": "段階割引",
  "detail.subscribeTip": "(購入{percent}%)",
  "detail.discountDetail": "🎯 割引段階明細",
  "detail.subscribeGte": "購入 ≥ {percent}%",
  "detail.currentSubscribe": "現在の購入 {percent}%、割引 -${discount}",
  "detail.total": "合計",
  "detail.btnFull": "⏳ 満員",
  "detail.btnEnded": "⏳ 終了",
  "detail.btnPending": "⏳ 未開始",
  "detail.btnRent": "🚀 今すぐレンタル",
  "detail.btnOutOfStock": "⏳ 在庫切れ",
  "detail.guaranteeSupport": "7×24 カスタマーサポート",
  "detail.guaranteeData": "データセキュリティ保証",
  "detail.guaranteeSla": "99.9% SLA",
  "detail.recommendBadge": "🔄 あなたにおすすめ",
  "detail.recommendTitle1": "おすすめ",
  "detail.recommendTitle2": "サーバー",
  "detail.recValue": "価値",
  "detail.recDetail": "詳細を見る →",
  "detail.faqBadge": "❓ よくある質問",
  "detail.faqTitle1": "レンタル",
  "detail.faqTitle2": "FAQ",
  "detail.chartModalTitle": "📈 収益トレンドグラフ",
  "detail.spec0": "エントリー版",
  "detail.spec1": "ライト版",
  "detail.spec2": "パフォーマンス版",
  "detail.spec3": "フラッグシップ版",
  "detail.spec4": "スーパーフラッグシップ",
  "detail.faq1Q": "サーバーレンタルに保証金は必要ですか？",
  "detail.faq1A":
    "初回レンタルユーザーには、一定割合の保証金をお支払いいただく場合があります。長期取引のお客様は保証金減免の対象となります。詳細は決済ページをご確認ください。",
  "detail.faq2Q": "レンタル期間満了後の更新方法は？",
  "detail.faq2A":
    "コントロールパネルの「マイレンタル」ページから更新手続きができます。日単位、週単位、月単位、四半期単位で更新可能で、更新価格は現在のレンタル価格と同じです。",
  "detail.faq3Q": "サーバーに障害が発生した場合は？",
  "detail.faq3A":
    "24時間365日のテクニカルサポートを提供しています。ハードウェア障害の場合、2時間以内に対応し、24時間以内に修理または交換を完了します。",
  "detail.faq4Q": "レンタルを早期に終了できますか？",
  "detail.faq4A":
    "はい、可能です。早期終了には、残りのレンタル期間の30%の違約金がかかります。詳細な条件はレンタル時に「レンタルサービス契約」をよくお読みください。",
  "detail.faq5Q":
    "レンタルサーバーのデータセキュリティはどのように保証されていますか？",
  "detail.faq5A":
    "エンタープライズレベルのデータ暗号化技術を採用し、すべてのデータは転送中および保存中に暗号化されます。レンタル終了後、データは完全に消去されます。",
  "detail.unitWan": "万",
  "detail.msgOutOfStock": "このサーバーは現在在庫切れです",
  "detail.msgSelectShare": "購入シェアを選択してください",
  "detail.msgRentFail": "レンタル失敗",
  "detail.msgRentSuccess": "レンタル成功",
  "detail.msgContact": "カスタマーサポートにお問い合わせください：400-888-8888",
  "detail.pwdTitle": "レンタル確認",
  "detail.pwdLabel": "取引パスワードを入力",
  "detail.pwdPlaceholder": "取引パスワードを入力",
  "detail.pwdConfirm": "レンタルを確認",
  "detail.pwdCancel": "キャンセル",
  "detail.rentNow": "💎 今すぐレンタル",
  "detail.rentAmount": "レンタル金額",
  "detail.subscribe": "購入",
  "detail.descProduct": "製品説明",
  "detail.descRegion": "地域情報",
  "detail.rentNowBtn": "🚀 今すぐレンタル",
  "detail.outOfStock": "⏳ 一時的に在庫切れ",
  "detail.stages": "段階",
  "detail.discount": "割引",
  "detail.rentConfirm": "レンタル確認",
  "detail.enterPassword": "取引パスワードを入力してください",
  "detail.confirmRent": "レンタルを確認",
  "detail.cancel": "キャンセル",
  "detail.rentyunxz": "稼働中",
  "detail.outOfStockMsg": "このサーバーは一時的に在庫切れです",
  "detail.selectShareMsg": "購入シェアを選択してください",
  "detail.rentFail": "レンタルに失敗しました",
  "detail.rentSuccess": "レンタルに成功しました",
  "detail.contactService": "サポートにお問い合わせください：400-888-8888",
  "detail.tenThousand": "万",

  // ===== コンピューティング情報ページ =====
  "info.emptyTitle": "現在コンピューティングサーバーはありません",
  "info.emptyDesc":
    "近日公開予定です。より多くの優れたコンピューティングリソースを準備しています",
  "info.collapse": "折りたたむ",
  "info.expand": "展開",
  "info.collapseDetail": "詳細を折りたたむ",
  "info.expandDetail": "詳細を展開",
  "info.priceTrend": "📈 価格トレンド",
  "info.unit": "単位",
  "info.latestPrice": "最新価格",
  "info.lastPrice": "前日価格",
  "info.increase": "上昇率",
  "info.buyNow": "今すぐ購入",
  "info.buyCompute": "コンピューティングパワーを購入",
  "info.selectPeriod": "期間を選択",
  "info.day": "日",
  "info.periodTime": "期間",
  "info.purchaseQuantity": "購入数量",
  "info.expectedProfit": "推定収益",
  "info.profitTip":
    "推定収益は過去の平均値です。実際の収益は決済データに基づきます。",
  "info.baseProfit": "基本収益",
  "info.settle24h": "24時間決済",
  "info.periodProfit": "期間収益",
  "info.settleDue": "期限切れ決済",
  "info.totalProfit": "総収益",
  "info.fundDetail": "資金明細",
  "info.purchaseAmount": "購入金額",
  "info.buyFormula": "最新価格x購入数量",
  "info.fee": "手数料",
  "info.feeFormula": "購入金額*{fee}%",
  "info.total": "合計",
  "info.cancel": "キャンセル",
  "info.confirmBuy": "購入を確認",
  "info.tradeConfirm": "取引確認",
  "info.enterPassword": "取引パスワードを入力",
  "info.confirmPay": "支払いを確認",
  "info.chart7d": "7日",
  "info.chart15d": "15日",
  "info.chart30d": "30日",
  "info.price": "価格",
  "info.maxValue": "最大値",
  "info.noData": "データがありません",
  "info.fetchFail": "データの取得に失敗しました",
  "info.selectProduct": "製品を選択してください",
  "info.quantityMin": "購入数量は1以上である必要があります",
  "info.priceError": "現在の価格が異常です。しばらくしてから再試行してください",
  "info.buySuccess": "購入成功！",
  "info.tradeFail": "取引に失敗しました。しばらくしてから再試行してください",
  "info.passwordError": "取引パスワードが正しくありません。再入力してください",
  "info.buyFail": "購入に失敗しました。しばらくしてから再試行してください",

  // ===== 会社概要ページ =====
  "about.tocTitle": "📑 目次",
  "about.toc1": "デジタルゴールドを掌握する",
  "about.toc2": "中核製品マトリックス",
  "about.toc3": "Aetrivolの安全性と信頼性",
  "about.toc4": "投資価値",
  "about.section1Title":
    "デジタルゴールドを掌握する：インテリジェント時代の「スーパー新コンピューティングロード」になる",
  "about.section1P1":
    "グローバル大規模モデルが兆パラメータの決戦に突入し、具身知能が全面的に爆発する今日、コンピューティングパワーは石油に取って代わり、世界の富を支配する究極のハードカレンシーとなっています。テクノロジー大手はGPUを狂ったように買い漁り、数億ものAIコンピューティングセンターの建設コストは一般投資家を締め出しています。Aetrivolは時代に応えて生まれました。革新的なコンピューティングパワー値のアンカリングメカニズムとコンピューティングサーバーレンタルモデルを通じて、資産の独占を打ち破り、最もシンプルで柔軟な方法で、人類史上最大の富の複利の宴を直接享受できます。",
  "about.section2Title": "中核製品マトリックス：ツインホイール駆動の富エンジン",
  "about.section2H1":
    "革新的製品1：【コンピューティングパワー値（Compute Value / CV）】——グローバルコンピューティング資産の「トークン化された配当」",
  "about.section2P1":
    "· 参入障壁を打破し、ミクロ資産化：グローバルな物理AIコンピューティングセンター、ハイエンドGPUサーバー（NVIDIA Blackwell、Huawei Ascendなど）の全体的なコンピューティングパワーを標準化して分割します。1ポイントの【コンピューティングパワー値】は、グローバルAIコンピューティングネットワークにおける特定のシェアのコンピューティング所有権を表します。",
  "about.section2P2":
    "· ファンドを買うようにGPUを購入：最低限の資金で【コンピューティングパワー値】を購入するだけで、「1枚のGPUも手に入らない」という壁を打ち破ります。保有するコンピューティングパワー値はプラットフォーム上で24時間稼働し続け、グローバルな大規模AIモデルやエージェントの呼び出しによって生み出されるデジタルキャッシュフローの配当を毎日受け取ることができます。",
  "about.section2P3":
    "· 高い流動性、いつでも現金化：コンピューティングパワー値は非常に高い資産流動性を持ちます。グローバルなコンピューティング需要の急増に伴い、コンピューティングパワー値自体に高いプレミアム余地があり、いつでもプラットフォーム上で取引して現金化できます。",
  "about.section2H2":
    "中核事業2：【コンピューティングサーバーレンタル（Server Leasing）】——安定した長期契約の「デジタル大家さん」モデル",
  "about.section2P4":
    "· 物理資産の購入、専用サーバーの所有権：投資家はプラットフォーム上のサーバー全体または標準ラックのコンピューティングサーバーを直接購入できます。各サーバーはチェーン上で実際にマッピングされ、固有の物理マシンSNコードを持ちます。",
  "about.section2P5":
    "· 長期委託リース、安定した高賃料収入：購入後、サーバーはプラットフォームのグローバルグリーンコンピューティングハブ（中国西部の東数西算ノード、北欧、中東など）のトップクラスのAIコンピューティングセンターに直接委託されます。プラットフォームが代わりにサーバーを、コンピューティングパワーを緊急に必要とする大規模モデル開発会社、大学研究所、または垂直分野のAI企業に正確にリースし、3～5年の長期契約による安定した高リターンの賃料を確保します。",
  "about.section3Title": "Aetrivolがリスクを絶対的な確実性に変える理由",
  "about.section3P1":
    "· 100% 物理資産のチェーン上のアンカリング：空中楼閣を拒否します。保有するコンピューティングパワー値であれ、リースするサーバーであれ、チェーン上でリアルタイムに、並列稼働し、高音を響かせる物理アクセラレータカードハードウェアにマッピングされており、資産は見え、触れ、検証可能です。",
  "about.section3P2":
    "· トップクラスのエネルギー効率と「地政学リスク」に対する二重の保険：当社がパッケージ化するデータセンターは、100%「小型モジュール炉（SMR）/太陽光直接供給」電力を備えているか、または絶対的に安全な非紛争法域に位置しており、地域的な電力網の問題や地政学的変動のリスクを完全に回避します。",
  "about.section3P3":
    "· 大手の信用保証と長期契約保証：プラットフォームは、Microsoft、OpenAI、DeepSeekなどの大規模モデル大手が事前にリースを確保している成熟したサイトを優先的に選択し、テクノロジー大手の信用を収益の保証として利用します。",
  "about.section4Title":
    "かつて彼らは土地に投資し、石油に投資しました。今日、私たちはコンピューティングパワーに投資します。",
  "about.section4P1":
    "全人類の知性とビジネスがデジタル世界に移行するとき、コンピューティングパワーはこの新しい世界の唯一の建築材料です。Aetrivolに参加し、コンピューティングパワー値を購入し、コンピューティングサーバーレンタルの旅を始めましょう。あなたの資本を、世界を再形成するコンピューティングの原子に変換し、このインテリジェンス急増の富の急騰を共有しましょう！",

  agreement: agreementContent,
};
